import axios from "axios";
import { IAuthResponse } from "../interfaces/auth.interface";

export const getToken = (refreshToken: string): Promise<IAuthResponse> => {
  return axios.post('/api/auth/refresh', { refreshToken }).then(res => res.data);
};

export const login = (login: string, password: string): Promise<IAuthResponse> => {
  return axios.post('/api/auth', { login, password }).then(res => res.data);
}